import React from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { Notice } from '../../../ui/Notice';
import { useResolve } from '../../Container';
import { AccountModel } from '../AccountModel';

export const NoWorkspaceBlock = () => {

    const account = useObserver(useResolve(AccountModel));
    const teams = account.workspaces.filter(x => x.type === 'team' || x.type === 'user');

    if (teams.length > 0) return null;

    return <Notice icon="exclamation">
        <span>You are not a member of any teams.  Speak to an organization admin to be added to a team.</span>
    </Notice>;
};
